import { FC } from 'react';
import ModalAtom from 'components/atoms/ModalAtom';
import PrimaryButton from 'components/atoms/Button/PrimaryButton';
import DefaultButton from 'components/atoms/Button/DefaultButton';

interface Props {
  title: string;
  text: string;
  mainButtonText: string;
  secondaryButtonText: string;
  onClickMainButton: () => Promise<void>;
  onCancel: () => void;
  visible: boolean;
  loading: boolean;
  isMainButtonDisabled?: boolean;
}

const ConfirmModal: FC<Props> = ({
  title,
  text,
  mainButtonText,
  secondaryButtonText,
  onClickMainButton,
  onCancel,
  visible,
  loading,
  isMainButtonDisabled,
}) => {
  return (
    <ModalAtom
      title={title}
      onCancel={onCancel}
      open={visible}
      destroyOnClose
      footer={[
        <DefaultButton key={'back'} onClick={onCancel} title={secondaryButtonText} />,
        <PrimaryButton key={'confirm'} loading={loading} title={mainButtonText} onClick={onClickMainButton} disabled={isMainButtonDisabled} />,
      ]}
    >
      <div>{text}</div>
    </ModalAtom>
  );
};

export default ConfirmModal;
